import { Card, Tabs } from "antd";
import Banners from "./Banners";
import DealBanners from "./DealBanners";
import Emoji from "./Emoji";
import SponsorPage from "./Sponsor";
import EventsPage from "./Events";
import TermsConditions from "./TermsConditions";
import PrivacyPolicy from "./PrivacyPolicy";
import CarouselBanners from "./CarouselBanners";

const BusinessProfile = () => {
  const onChange = (key) => {};
  const items = [
    {
      key: "0",
      label: "Banners",
      children: <Banners />,
    },
    {
      key: "1",
      label: "Flash Deals Banners",
      children: <DealBanners />,
    },
    {
      key: "2",
      label: "Emoji",
      children: <Emoji />,
    },
    {
      key: "3",
      label: "Sponsor",
      children: <SponsorPage />,
    },
    {
      key: "4",
      label: "Events",
      children: <EventsPage />,
    },
    {
      key: "5",
      label: "Terms & Conditions",
      children: <TermsConditions />,
    },
    {
      key: "6",
      label: "Privacy Policy",
      children: <PrivacyPolicy />,
    },
    {
      key: "7",
      label: "Carousel Banners",
      children: <CarouselBanners />,
    },
  ];
  return (
    <>
      <div className="grid gap-2 space-x-2 w-full pr-2">
        <div className="flex items-center ml-2 mt-2 ">
          <span className="text-lg font-medium text-black ml-1">Settings</span>
        </div>
        <div>
          <Card className="rounded-2xl bg-white xl:relative">
            <div className="border-solid border-inputFieldGrey rounded-sm p-2 lg:px-5">
              <Tabs defaultActiveKey="0" items={items} onChange={onChange} />
            </div>
          </Card>
        </div>
      </div>
    </>
  );
};
export default BusinessProfile;
